import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import Topbar from '../layout/Topbar';
import { aggiungiUtente } from '../../actions/auth';

const AggiungiUtente = ({ auth: { user, loading }, alert, aggiungiUtente }) => {
    const initialState = {
        username: '',
        email: '',
        ruolo: 'magazziniere', 
        password: ''
    }
  const [utenteData, setUtenteData] = useState(initialState);

  const { username, email, ruolo, password } = utenteData;

  useEffect(() => {
    const size = alert.length;
    if (size > 0) {
        if (alert[size - 1].alertType === "success") {
            setUtenteData(initialState);
        }
    }
}, [alert]);

if (user && user.ruolo !== 'admin') {
  return <Redirect to="/gestione-magazzino" />;
}



  const onChange = e => {
    setUtenteData({ ...utenteData, [e.target.name]: e.target.value });
  };

  const onSubmit = async e => {
    e.preventDefault();
    aggiungiUtente({ username, email, ruolo, password });
  };

 

  return (loading ? <Spinner /> :
    <div className="section lightblue user-block wf-section">
      <Topbar
        labelPagina={"Gestione utenti"}
        isFolder={false}
      />
      <div className="container flex-center">
        <div className="form-wrap wide">
          <div className="form-block w-form">
            <form id="wf-form-aggiungi-utente" name="wf-form-aggiungi-utente" data-name="aggiungi-utente" className="form" onSubmit={e => onSubmit(e)}>
              <h3 id="w-node-e7570c72-74ce-9da3-f85d-1baca43dd698-1ef19627" className="no-margin">Aggiungi utente</h3>
                  <div id="w-node-d856d2e4-08c5-88c1-6f58-7170b4b93772-347debdf" className="column">
                    <label htmlFor="username" className="form-label">Username <span className="required">*</span></label>
                    <input type="text" className="input-field w-input" maxLength="256" name="username" data-name="username" placeholder="Inserire username" id="username" value={username} onChange={e => onChange(e)} required="true"/>
                  </div>
                  <div id="w-node-d856d2e4-08c5-88c1-6f58-7170b4b93772-347debdf" className="column">
                    <label htmlFor="email" className="form-label">Email <span className="required">*</span></label>
                    <input type="email" className="input-field w-input" maxLength="256" name="email" data-name="email" placeholder="Inserire email" id="email" value={email} onChange={e => onChange(e)} required="true" />
                  </div>
                  <div id="w-node-d856d2e4-08c5-88c1-6f58-7170b4b93772-347debdf" className="column">
                    <label htmlFor="password" className="form-label">Password <span className="required">*</span></label>
                    <input type="password" className="input-field w-input" maxLength="256" name="password" data-name="password" placeholder="Inserire password" id="password" value={password} onChange={e => onChange(e)} required="true" />
                  </div>
                  <div id="w-node-d856d2e4-08c5-88c1-6f58-7170b4b93772-347debdf" className="column">
                    <label htmlFor="ruolo" className="form-label">Ruolo <span className="required">*</span></label>
                    <select
                      className="input-field w-input"
                      name="ruolo"
                      data-name="ruolo"
                      id="ruolo"
                      value={ruolo}
                      onChange={e => onChange(e)}
                      required="true" 
                    >
                      <option value="admin">admin</option>
                      <option value="magazziniere">magazziniere</option>
                    </select>
                  </div>
              <input type="submit" value="Salva nuovo utente" data-wait="Un attimo..." id="w-node-fcbab871-ad04-d61a-20e1-9b99f7049d2b-40413f47" className="submit-button w-button" />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

AggiungiUtente.propTypes = {
  auth: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  aggiungiUtente: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    alert: state.alert
});

export default connect(mapStateToProps, { aggiungiUtente })(AggiungiUtente);
